import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react';

const everythingExists = (dependencies: DependencyList) => dependencies.every((dep) => dep != null);

const useEffectOnceWhenDepsExist = (callback: EffectCallback, dependencies: DependencyList) => {
  const hasExecuted = useRef(false);

  useEffect(() => {
    if (everythingExists(dependencies) && !hasExecuted.current) {
      callback();
      hasExecuted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useEffectOnceWhenDepsExist;
